var currentCheckoutCallback = null;
export var setCheckoutCallback = function setCheckoutCallback(callback) {
  currentCheckoutCallback = callback;
};
export var clearCheckoutCallback = function clearCheckoutCallback() {
  currentCheckoutCallback = null;
};
export var paddleEventCallback = function paddleEventCallback(eventData) {
  if (eventData.name === 'checkout.completed') {
    var _window$Paddle;
    currentCheckoutCallback(true);
    if ((_window$Paddle = window.Paddle) !== null && _window$Paddle !== void 0 && _window$Paddle.Checkout) {
      window.Paddle.Checkout.close();
    }
    if (currentCheckoutCallback) {
      currentCheckoutCallback(true);
      clearCheckoutCallback();
    }
  }
  if (eventData.name === 'checkout.closed') {
    if (currentCheckoutCallback) {
      currentCheckoutCallback(false);
      clearCheckoutCallback();
    }
  }
};